<template>
  <a-loading :loading="integrationMeta.loading">
    <integration-form
      mode="edit"
      :integration="integration"
      @submit="handleSubmit"
      @delete="handleDelete"
    />
  </a-loading>
</template>

<script>
  import { IntegrationForm } from '@/components'
  import { useIntegration, useDeleteIntegration, useEditIntegration } from './integrationHooks'
  import { ALoading } from 'codefabrik-gui-vue'

  export default {
    name: 'EditIntegration',
    components: { IntegrationForm, ALoading },
    mixins: [
      useEditIntegration('handleSubmit'),
      useIntegration('integration'),
      useDeleteIntegration('handleDelete')
    ]
  }
</script>

<style scoped>

</style>
